export default "__VITE_ASSET__I28cDJ2D__"